import axios from 'axios';
import { IFacebookResponse } from '../interfaces/ISocial';

export async function getFacebookUserInformation(
  accessToken: string
): Promise<IFacebookResponse | null> {
  try {
    const res = await axios.get('https://graph.facebook.com/v19.0/me', {
      params: {
        access_token: accessToken,
        fields: 'id,name,email,picture.type(normal),birthday',
        format: 'json',
        method: 'get',
        transport: 'cors'
      }
    });

    return res?.data;
  } catch {
    return null;
  }
}
